import { render } from "./GreenBanner.vue?vue&type=template&id=43ea4d09&scoped=true"
import script from "./GreenBanner.vue?vue&type=script&lang=js"
export * from "./GreenBanner.vue?vue&type=script&lang=js"

import "./GreenBanner.vue?vue&type=style&index=0&id=43ea4d09&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ea4d09"]])

export default __exports__